import { render, staticRenderFns } from "./CustomerReports.vue?vue&type=template&id=bc607496&scoped=true&"
import script from "./CustomerReports.vue?vue&type=script&lang=ts&"
export * from "./CustomerReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc607496",
  null
  
)

export default component.exports